module.exports = __webpack_public_path__ + "static/media/elements-of-trust.a96b655f.png";